import React, { useState, useEffect } from "react";
import { useWeightContext } from "../context/appContext";
import RadioInput from "../../../containers/input.radio";
import ContainerWithTitle from "../../../containers/title.container";
import ButtonContainer from "../../../containers/button";

const QuestionEight = ({ onNext, onPrev }) => {
  const { payload, setPayload, currentPage, setCurrentPage, setErrorMessage } =
    useWeightContext();
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(payload?.sleep || "");
  }, [currentPage, payload]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (value) {
      onNext(value);
    } else {
      setErrorMessage("Please select an option.");
    }
  };

  const handleRadioChange = (event) => {
    setErrorMessage(null);
    window.gtag({
      event: "user_sleep",
      data: {
        sleep: event.target.value,
      },
    });
    if (window.fbq) {
      window.fbq("track", "user_sleep", {
        sleep: event.target.value,
      });
    }
    setValue(event.target.value);
    onNext(event.target.value);
  };

  return (
    <ContainerWithTitle
      title="How many hours of sleep do you get in a night on average?"
      handleBack={onPrev}
      isContinueButton={false}
    >
      <div className="radio-container flex lg:flex-row flex-col whitespace-pre">
        <RadioInput
          label="Less than 5 hours"
          value="below-5"
          colorChecked={value === "below-5"}
          onChange={handleRadioChange}
        />
        <RadioInput
          label="Between 5-7 hours"
          value="5-7"
          colorChecked={value === "5-7"}
          onChange={handleRadioChange}
        />
        <RadioInput
          label="7 or more hours"
          value="7-plus"
          colorChecked={value === "7-plus"}
          onChange={handleRadioChange}
        />
      </div>
      {/* <ButtonContainer onClick={handleSubmit}>Next</ButtonContainer> */}
    </ContainerWithTitle>
  );
};

export default QuestionEight;
